import styled from '../../../styled';
const BottomContainer = styled.div `
  position: relative;
  height: auto;
  width: ${({ width }) => width};
`;
export default BottomContainer;
//# sourceMappingURL=BottomContainer.js.map